import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import PropTypes from 'prop-types';



const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip placement="top" {...props} classes={{ popper: className }} />
))(({ theme, bgColor, textColor }) => ({
    "& .MuiTooltip-tooltip": {
        backgroundColor: bgColor || theme.palette.background.default,
        color: textColor || theme.palette.text.white,
        fontSize: "0.875rem",
        padding: "8px 12px",
        "& .MuiBox-root": {
            alignItems: "center"
        }
    },
    "& .MuiTooltip-arrow": {
        color: bgColor || theme.palette.background.default,
    },

}));

const TooltipWrapper = ({ tooltip, title, bgColor, textColor, children }) => {
    if (!tooltip) {
        return children;
    }

    return (
        <CustomTooltip title={title} bgColor={bgColor} textColor={textColor} arrow>
            <span style={{ display: "inline-flex", alignItems: "center" }}>{children}</span>
        </CustomTooltip>
    );
};

TooltipWrapper.propTypes = {
    tooltip: PropTypes.bool,
    title: PropTypes.node.isRequired,
    bgColor: PropTypes.string,
    textColor: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default TooltipWrapper;